import { deviceMatcher } from "./device-matcher";
import { regionMatcher, type GeoData } from "./region-matcher";
import { samplingMatcher } from "./sampling-matcher";
import {
  type BucketingResult,
  type BucketingMatcherSelector,
  getBucketingMatcherSelector,
} from "./bucketing-matcher";
import type { InstantConfigGroup } from "../config/types";

export {
  deviceMatcher,
  regionMatcher,
  samplingMatcher,
  getBucketingMatcherSelector,
};

export interface GroupMarker {
  deprecatedMark(key: string, sampling: number, active: boolean): void;
  mark(bucketingResult: BucketingResult): void;
}

export interface KeyValuesProvider {
  getKeyValues(): string[];
  getLabradorKeyValues(): string[];
}

export type Matcher = (group: InstantConfigGroup) => boolean;

export type DefaultMatchersParams = {
  device?: string;
  geo: GeoData;
};

export const defaultMatchers = ({ device, geo }: DefaultMatchersParams) => {
  return [deviceMatcher(device), regionMatcher(geo)];
};

export type { GeoData, BucketingResult, BucketingMatcherSelector };
